export const spanFerkel = (s) => {
	if ( s ) {
		return `<div><mark>${
			s.split( '' ).map(
				c => ( c.toLowerCase() !== c ? `<span>${c}</span>` : `<span>${c}</span>` ),
			).join( '' )
				.split( ' ' )
				.join( '</mark> <mark>' )
		}</span></div>`;
	}
	return '';
};


export const map = (value, a, b, c, d) => {
	value = (value - a) / (b - a);
	return c + value * (d - c);
}

export const shuffle = (o) => {
	for(var j, x, i = o.length; i; j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
	return o;
};

export const clamp = (value, min = 0, max = 1) => {
		return Math.min(Math.max(value, min), max);
}